import {REQUIRED_FIELD} from "../../../../../constants";
import {addValidations} from "../../../../../utils/validation";
import { Label } from "../../../../../components/formInputs";
import { SelectField, TextField } from "../../../../../components/formikFormInputs";
import { getMonths, getNextYears } from "../../../Enrollment/EnrollmentHome/basicInfo/PersonalDetailForm";
import moment from "moment/moment";
import { checkProofExpiry } from "../../../../../utils/commonUtils";
import React from "react";



// fieldsVisible tag will be removed if fields will available for all UploadSpecificDocument.tsx popup uses
export const validate = (fieldsVisible: boolean = false) => {
    let keysValidation = {
        documentSubType: addValidations({
            type: "string",
            required: true,
        }),
    }
    const validationObjs = [
        {
            fieldName: "identityId",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Passport", "Drivers License"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "proofExpiryMonth",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Passport", "Drivers License"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "proofExpiryYear",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Passport", "Drivers License"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "employeeIdState",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Passport", "Drivers License"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },

        //
        {
            fieldName: "greenCardNo",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Green Card", "Permanent Residency Card"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "greenCardExpiryMonth",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Green Card", "Permanent Residency Card"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "greenCardExpiryYear",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Green Card", "Permanent Residency Card"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        // visa
        {
            fieldName: "typeOfVisaPlanHeld",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Visa"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "visaExpiryMonth",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Visa"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        },
        {
            fieldName: "visaExpiryYear",
            type: "string",
            nullable: true,
            when:[["documentSubType"], {
                is: (value) => { return ["Visa"].includes(value) },
                then: (schema) => schema.required(REQUIRED_FIELD),
                otherwise: (schema) => schema.notRequired().nullable(),
            }]
        }
    ]

    fieldsVisible && validationObjs.forEach((obj:any) =>{
        keysValidation[obj.fieldName] = addValidations(obj);
    })
    return keysValidation;

};

// render document information field to updated document related data
// fieldsVisible tag will be removed if fields will available for all UploadSpecificDocument.tsx popup uses
export const documentInformationFields:any = (document:string, fieldsVisible: boolean = false) => {
    // if fields not visible just return empty array
    if(!fieldsVisible){
        return []
    }
    switch (document) {
        case "Passport":
        case "Drivers License":
            return [
                {
                    name: "identityId",
                    helperFieldText: "Must be a valid drivers license",
                    label: <Label label={document == "Drivers License" ? "Enter drivers license number" : "Enter passport number"} required={true}/>,
                    isRequired: true,
                    className: "mt35 TextFieldWidth",
                    filedType: "string",
                    component: TextField,
                    size:12,
                    variant: "outlined",
                },
                {
                    name: "proofExpiryMonth",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    isRequired: true,
                    filedType: "selectbox",
                    label: <Label label="Month" required={true}/>,
                    size:4,
                    options: getMonths(),
                    onSelectChange: (val: number) => {
                    },
                    getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                        if (val && formValues["proofExpiryYear"]) {
                            const endOfMonth = moment(formValues["proofExpiryYear"] + "-" + val).endOf("month").format("D");
                            const date = new Date(formValues["proofExpiryYear"] + "-" + val + "-" + endOfMonth);
                            const result = checkProofExpiry(date);
                            // setProofExpired(result);
                        }
                    },
                }, {
                    name: "proofExpiryYear",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    isRequired: true,
                    label: <Label label="Year" required={true}/>,
                    size:4,
                    options: getNextYears(),
                    onSelectChange: (val: number) => {
                    },
                    getValuesOnChange: (val: number, setValue: Function, formValues: any) => {
                        if (val && formValues["proofExpiryMonth"]) {
                            const endOfMonth = moment(val + "-" + formValues["proofExpiryMonth"]).endOf("month").format("D");
                            const date = new Date(val + "-" + formValues["proofExpiryMonth"] + "-" + endOfMonth);
                            const result = checkProofExpiry(date);
                            // setProofExpired(result);
                        }
                    },
                },
                {
                    name: "employeeIdState",
                    label: <Label label={"State"} required={true}/>,
                    isRequired: true,
                    component: TextField,
                    className: "TextFieldWidth",
                    variant: "outlined",
                    size:4,
                    // options: stateDropDownArr,
                    onSelectChange: (val: number) => {
                    },
                },

            ]
        case "Green Card":
        case "Permanent Residency Card":
            return [
                {
                    id: "greenCardNo",
                    name: "greenCardNo",
                    label : "Card Number",
                    component: TextField,
                    isRequired: true,
                    variant: "outlined",
                    className: "TextFieldWidth",
                    size:12,
                },
                {
                    name: "greenCardExpiryMonth",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    filedType: "selectbox",
                    label: <Label label={"Month"} required={true} />,
                    options: getMonths(),
                    size:6,
                    // key: values && values["greenCardExpiryMonth"],
                    isRequired: true,
                },
                {
                    name: "greenCardExpiryYear",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    label: <Label label={"Year"} required={true} />,
                    isRequired: true,
                    size:6,
                    // key: values && values["greenCardExpiryYear"],
                    options: getNextYears(),
                }
            ]
        case "Visa":
            return [
                {
                    id: "typeOfVisaPlanHeld",
                    name: "typeOfVisaPlanHeld",
                    label : "Type of VISA held",
                    component: TextField,
                    isRequired: true,
                    variant: "outlined",
                    className: "TextFieldWidth",
                    size:12,
                },
                {
                    name: "visaExpiryMonth",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    filedType: "selectbox",
                    label: <Label label={"Month"} required={true} />,
                    options: getMonths(),
                    isRequired: true,
                    size:6,
                    // value: values && values["visaExpiryMonth"],
                    // key: values && values["visaExpiryMonth"],
                    onSelectChange: (val: number) => {
                    },
                },
                {
                    name: "visaExpiryYear",
                    component: SelectField,
                    className: "SelectFieldWidth",
                    variant: "outlined",
                    label: <Label label={"Year"} required={true} />,
                    isRequired: true,
                    size:6,
                    options: getNextYears(),
                    // key: values && values["visaExpiryYear"],
                }
            ];
        default:
            return []
    }
}